import headerImage from './components/headerImage';
import style from './components/style';

module.exports = {
  text: 'Generic Template (Customisable)',
  value: 'generic',
  subject: 'A message from Real Links',
  mjml(params) {
    const { brandingSettings: branding } = params;
    const slots = params.slots.map(({ content }) => ({
      content: content
        .replace(/{{[\s]*company\.name[\s]*}}/g, '{{defaults company.branding.name company.name "Referrals"}}'),
    }));

    return `<mjml>
      <mj-head>
        <mj-title>${params.subject}</mj-title>
        <mj-include path="../include/styles.mjml"/>
        <mj-attributes>
          <mj-class name="content" border-radius="4px"/>
        </mj-attributes>
        <mj-style>
          ${style(branding)}
        </mj-style>
      </mj-head>
      <mj-body width="760px" background-color="${branding.backgroundColour || '#ffffff'}">
        ${!branding.hideBrandLogo ? `<mj-section>
          <mj-column>
            <mj-include path="../include/branding-logo.mjml"/>
          </mj-column>
        </mj-section> ` : ''}

        ${branding.headerImage ? headerImage(branding.headerImage) : ''}

        <mj-section mj-class="content">
          <mj-column>
            <mj-text>${slots[0].content}</mj-text>
          </mj-column>
        </mj-section>

        <mj-include path="../include/footer-disclaimer.mjml"/>
      </mj-body>
    </mjml>`;
  },
  slots: [
    {
      name: 'Main Content',
      type: 'html',
      defaultContent: `
        <p>Dear {{user.firstName}},</p>
        <p>Thanks for joining {{company.name}}. It's time to get sharing.</p>
        <p>Thanks</p>
        <p>The {{company.name}} team</p>
      `,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/emails/generic.js